import type { JSONContent } from '@tiptap/core';

/** JSONB reorders keys; Tiptap adds presentation defaults that are not source content. */
export function authoringJsonFingerprint(value: unknown): string {
  return JSON.stringify(value, (_key, entry: unknown) => {
    if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return entry;
    let record = entry as Record<string, unknown>;
    if (record.attrs && typeof record.attrs === 'object' && !Array.isArray(record.attrs)) {
      const attrs = { ...record.attrs } as Record<string, unknown>;
      if (record.type === 'link') {
        delete attrs.target; delete attrs.rel; delete attrs.class;
      }
      if (record.type === 'orderedList' && (attrs.type == null || attrs.type === '1')) delete attrs.type;
      if ((record.type === 'tableCell' || record.type === 'tableHeader') && attrs.align == null) delete attrs.align;
      if (record.type === 'doc') {
        // The editor's root extension supplies null defaults for ordinary documents.
        for (const key of ['documentType', 'templateId', 'effectiveDate', 'revision', 'formVersionIds', 'localizedMetadata', 'layoutVersion']) if (attrs[key] == null) delete attrs[key];
      }
      // Optional formatting attributes are absent on older source documents.
      for (const key of ['textAlign', 'lineHeight', 'spacingBefore', 'spacingAfter', 'indent', 'textIndent', 'fontSize', 'color', 'backgroundColor', 'padding', 'borderWidth', 'borderStyle', 'borderColor', 'rowHeight', 'tableWidth', 'numbered', 'numberStart', 'numberPrefix', 'hierarchical']) if (attrs[key] == null) delete attrs[key];
      record = { ...record, attrs };
      if (!Object.keys(attrs).length) delete record.attrs;
    }
    return Object.fromEntries(Object.keys(record).sort().map((key) => [key, record[key]]));
  });
}

export const authoringSourceContent = (content: JSONContent): JSONContent => JSON.parse(authoringJsonFingerprint(content)) as JSONContent;
